import React, { useRef, Children, cloneElement, useEffect } from 'react';
import cx from 'classnames';
import { useDropdownKeyboardSupport } from '../hooks/useDropdownKeyboardSupport';
import styles from './Menu.module.css';
var FOCUS_DELAY = 50;
export var Menu = function (_a) {
    var isOpen = _a.isOpen, position = _a.position, children = _a.children, testId = _a["data-testid"], className = _a.className;
    var ref = useRef(null);
    var _b = useDropdownKeyboardSupport(), onKeyDown = _b.onKeyDown, optionsRef = _b.optionsRef;
    useEffect(function () {
        if (isOpen) {
            var option_1 = optionsRef.current.find(function (node) { return (node === null || node === void 0 ? void 0 : node.getAttribute('aria-selected')) === 'true'; }) || optionsRef.current[0];
            // FOCUS_DELAY is required to delay focus till portal position is calculated and options are visible
            // there might be better solution though
            setTimeout(function () { return option_1 === null || option_1 === void 0 ? void 0 : option_1.focus(); }, FOCUS_DELAY);
        }
    }, [isOpen, optionsRef]);
    return (React.createElement("ul", { "data-testid": testId ? "".concat(testId, "Menu") : undefined, className: cx(styles.menu, className, styles[position]), ref: ref, role: "menu", onKeyDown: onKeyDown }, Children.map(children, function (child, index) {
        return cloneElement(child, {
            ref: function (childRef) {
                optionsRef.current[index] = childRef;
            },
            focusPrevious: function () { var _a; return (_a = optionsRef.current[index - 1]) === null || _a === void 0 ? void 0 : _a.focus(); },
            focusNext: function () { var _a; return (_a = optionsRef.current[index + 1]) === null || _a === void 0 ? void 0 : _a.focus(); },
            tabIndex: isOpen ? 0 : -1
        });
    })));
};
//# sourceMappingURL=Menu.js.map